import { useState } from "react";
import axios from "axios";
import { Lock, ArrowRight } from "lucide-react";
import { gtagEvent } from "@/lib/gtag";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validateGate(email, phone, g) {
  if (!email.trim() && !phone.trim()) return g.error;
  if (email.trim() && !EMAIL_RE.test(email.trim())) return g.emailError;
  return "";
}

async function submitLead({ name, email, phone, lang }) {
  try {
    await axios.post(`${API}/leads`, {
      name: name.trim() || null,
      email: email.trim() || null,
      phone: phone.trim() || null,
      language: lang,
    });
    gtagEvent("generate_lead");
  } catch (err) {
    // fail-soft: the visitor is never blocked by a lead API error
    if (process.env.NODE_ENV !== "production") {
      console.warn("Lead submission failed:", err?.message);
    }
  }
}

export default function CalcGate({ g, lang, onUnlock }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const validationError = validateGate(email, phone, g);
    if (validationError) return setError(validationError);
    setError("");
    setSending(true);
    await submitLead({ name, email, phone, lang });
    window.localStorage.setItem("att_calc_unlocked", "1");
    onUnlock();
  };

  return (
    <div className="card-surface p-6 sm:p-10 max-w-xl mx-auto text-center reveal" data-testid="calc-gate">
      <div className="w-12 h-12 mx-auto rounded-2xl bg-[var(--primary)] flex items-center justify-center mb-4">
        <Lock className="w-5 h-5 text-white" />
      </div>
      <h3 className="font-heading text-2xl mb-2">{g.title}</h3>
      <p className="text-[var(--body)] text-sm mb-6">{g.subtitle}</p>
      <form onSubmit={submit} className="space-y-3 text-left">
        <input className="input-field" placeholder={g.name} value={name} onChange={(e) => setName(e.target.value)} data-testid="calc-gate-name" />
        <input className="input-field" type="email" placeholder={g.email} value={email} onChange={(e) => setEmail(e.target.value)} data-testid="calc-gate-email" />
        <div className="text-center text-xs uppercase tracking-widest text-[var(--muted)]">{g.or}</div>
        <input className="input-field" type="tel" placeholder={g.phone} value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="calc-gate-phone" />
        {error && (
          <p className="text-sm font-semibold text-[var(--accent)]" data-testid="calc-gate-error">{error}</p>
        )}
        <button type="submit" disabled={sending} className="btn-primary w-full justify-center" data-testid="calc-gate-submit">
          {g.cta}
          <ArrowRight className="w-4 h-4" />
        </button>
      </form>
    </div>
  );
}
